import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-slides',
  templateUrl: './main-slides.component.html',
  styleUrls: ['./main-slides.component.css'],
})
export class MainSlidesComponent implements OnInit {
  @Input() active: boolean = false;

  constructor() {}

  ngOnInit(): void {}
}
